





























import Vue from 'vue';
import {EventApi} from '@/api/event-api';
import {EventType} from '@/types/event-type';
import {RoutsData} from '@/router/routs';
import {TicketApi} from '@/api/ticket-api';
import {MarkedForDeletion} from '@/types/marked-for-deletion';
import ActionConfirmation from '@/components/ActionConfirmation.vue';
import EventListItem from '@/components/EventListItem.vue';
import moment from 'moment';

export default Vue.extend({
  name: 'EventsList',
  components: {ActionConfirmation, EventListItem},
  beforeMount() {
    this.getData();
  },
  data() {
    return {
      events: [] as EventType[],
      addEvent: {name: RoutsData.EVENT_ADD.name},
      markedForDeletionEnum: MarkedForDeletion,
      isShowConfirm: {show: false, action: () => null, actionData: null, text: ''}
    };
  },
  computed: {
    past(): EventType[] {
      return this.events.filter((val: EventType) => moment(val.tsEnd).isBefore(Date.now()));
    },
    ongoing(): EventType[] {
      return this.events.filter((val: EventType) => moment(Date.now()).isBefore(val.tsEnd) && moment(Date.now()).isAfter(val.tsStart));
    },
    planned(): EventType[] {
      return this.events.filter((val: EventType) => moment(Date.now()).isBefore(val.tsStart));
    }
  },
  methods: {
    async getData() {
      await EventApi.getList().then(res => this.events = res.data);
      const ticketCount = await TicketApi.getCountByCategory(
          this.events
              .filter(e => e.ticketCategory && e.ticketCategory.length)
              .map(e => ({event: e.id, category: (e.ticketCategory as any[]).map(c => c.id)}))
      ).then(res => res.data.reduce((acc, curr) => {
        acc[curr.event] = curr.count;
        return acc;
      }, {} as { [eventId: string]: number }));

      this.events = this.events.map(e => ({...e, ticketNum: ticketCount[e.id] ? ticketCount[e.id] : 0}));
    },
    onDeleteEvent(item: EventType) {
      this.isShowConfirm.text = 'Пометить мероприяте на удаление?';
      this.isShowConfirm.action = () => {
        this.isShowConfirm.show = false;
        EventApi.delete(item.id).then(() => {
              this.$store.commit('setMessage', {
                show: true,
                text: 'Мероприятие помечено на удаление'
              });
              item.markedForDeletion = MarkedForDeletion.YES;
            }
        ).catch(() =>
            this.$store.commit('setMessage', {
              show: true,
              text: 'Произошла ошибка'
            }));

        return null;
      };
      this.isShowConfirm.actionData = null;
      this.isShowConfirm.show = true;
    }
  }
});
